import i18n from 'i18next';
import { getActualProduct } from '../../../ServiceSummary/utils';
import { baggageOptionItemFactory } from './baggageOptionItemFactory';
export function includedOptionItemFactory({ key, travellerId, segmentsGroupsCount, segments, includedService, products = [] }) {
    const { count, confirmedCount } = includedService;
    const isAllSegments = key === 'allSegments';
    const gdsServiceType = includedService.service.type;
    switch (gdsServiceType) {
        case 'Baggage':
            const baggageService = includedService.service;
            return baggageOptionItemFactory({
                key,
                travellerId,
                count,
                confirmedCount,
                segmentsGroupsCount,
                products,
                gdsService: baggageService,
                groupType: 'confirmed'
            });
        case 'Meal':
            const mealService = includedService.service;
            const segment = !isAllSegments && segments.find(segment => segment.id === key);
            const direction = segment
                ? `${segment.departure.airport.iata} – ${segment.arrival.airport.iata}`
                : i18n.t('All flights', { ns: 'Cart' });
            const actualProduct = getActualProduct(products);
            return {
                name: `${direction}, ${count}x ${mealService.name}`,
                id: mealService.id,
                segment: key,
                price: mealService.price,
                status: actualProduct === null || actualProduct === void 0 ? void 0 : actualProduct.status,
                included: count === confirmedCount
            };
        default:
            return null;
    }
}
